export default "__VITE_ASSET__vG5V$TZy__"